import React from "react";

import { MdDelete } from "react-icons/md";

export interface KeyValueItem {
  key: string;
  value: string;
}

const KeyValueList: React.FC<{
  items: KeyValueItem[];
  setItems: React.Dispatch<React.SetStateAction<KeyValueItem[]>>;
}> = ({ items, setItems }) => {
  const handleChange = (
    index: number,
    field: "key" | "value",
    newValue: string
  ) => {
    const updated = [...items];
    updated[index][field] = newValue;
    setItems(updated);
  };

  const addItem = () => {
    setItems([...items, { key: "", value: "" }]);
  };

  const deleteItem = (index: number) => {
    const updated = items.filter((_, i) => i !== index);
    setItems(updated);
  };

  return (
    <div className="w-full mb-4">
      {items.map((item, index) => (
        <div
          key={index}
          style={{
            display: "flex",
            gap: "10px",
            marginBottom: "10px",
            alignItems: "center",
          }}
        >
          <input
            type="text"
            placeholder="Key"
            value={item.key}
            onChange={(e) => handleChange(index, "key", e.target.value)}
            className="w-full text-[14px] px-4 border border-gray-200 placeholder:text-black text-black rounded-md bg-white py-1.5 focus:outline-none"
          />

          <input
            type="text"
            placeholder="Value"
            value={item.value}
            onChange={(e) => handleChange(index, "value", e.target.value)}
            className="w-full text-[14px] px-4 border border-gray-200 placeholder:text-black text-black rounded-md bg-white py-1.5 focus:outline-none"
          />

          <button
            onClick={() => deleteItem(index)}
            className="p-2 bg-red-500 text-white rounded-md cursor-pointer  disabled:opacity-50"
            disabled={items.length === 1}
          >
            <MdDelete />
          </button>
        </div>
      ))}
      <div className="w-full flex justify-end">
        <button
          onClick={addItem}
          type="button"
          className="text-xs ml-auto cursor-pointer underline"
        >
          Add More
        </button>
      </div>
    </div>
  );
};

export default KeyValueList;
